import React from 'react';
import {GenericSettingsModal} from 'components/modals';
import i18n from 'i18n';
import AudioAnonymizationTasksSettingsForm from './AudioAnonymizationTasksSettingsForm';

interface AudioAnonymizationTasksSettingsModalProps {
    modalOpen: boolean;
    closeModal: () => void;
    activeAudioAnonymizationTaskId: number;
}

const AudioAnonymizationTasksSettingsModal: React.FC<AudioAnonymizationTasksSettingsModalProps> = React.memo(({
    modalOpen,
    closeModal,
    activeAudioAnonymizationTaskId,
}) => (
    <GenericSettingsModal
        isOpen={modalOpen}
        onClose={closeModal}
        title={i18n.t('jt_audio_anonymisation_task_details.text')}
        entityId={activeAudioAnonymizationTaskId}
        entityIdPropName="audioAnonymizationTaskId"
        FormComponent={AudioAnonymizationTasksSettingsForm}
        includeOnSave={false}
    />
));

export default AudioAnonymizationTasksSettingsModal; 